import React, { useId } from 'react';
import styles from './forms.module.scss';
import { ConfigProvider, Input } from 'antd';
import { antdTheme as theme } from 'shared/constants';
import classNames from 'classnames';

const { TextArea } = Input;

/**
 * @typedef {import('antd').InputProps} TextAreaInputProps
 */

/**
 * @param {TextAreaInputProps & {marginBottom: boolean}} props
 */
export function TextAreaInput({
  marginBottom = true,
  label = null,
  error = null,
  size = 'large',
  name,
  id,
  ...props
}) {
  const generatedId = useId();
  const inputId = id || generatedId;

  return (
    <ConfigProvider
      theme={{
        components: {
          TextArea: {
            borderRadius: 8,
            colorBorder: theme.colorBorder,
            colorTextPlaceholder: theme.colorTextPlaceholder,
          },
        },
      }}>
      <div className={classNames(styles.root, { [styles.marginBottom]: marginBottom })}>
        {label && <label htmlFor={inputId}>{label}</label>}
        <TextArea id={inputId} name={name} status={error && 'error'} size={size} {...props} />
        <span className={styles.error}>{error}</span>
      </div>
    </ConfigProvider>
  );
}
